module.exports = __webpack_public_path__ + "media/react/lab/src/logo-5d5d9eefa31e5e13a6610d9fa7a283bb.svg";